// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"223":"commons","345":"component---src-templates-storyblok-page-js","718":"component---src-pages-success-js"}[chunkId] || chunkId) + "-" + {"223":"7f1beee676250e0b1ac1","345":"173d4e6b0a7e1604095d","522":"226d97ceefa4d0e86565","718":"4ad5b57c9135b62912fe"}[chunkId] + ".js";
};